import React from 'react';
import { zip } from '../../../utils/variablesEntornoExcel';
import '../../../stylesheets/stylesLayout/yourProperties.scss';
import IconButton from '../../../muiComponents/IconButton';
import useTranslate from '../../../customHooks/useTranslate';

const PropertiesMessageInfo = props => {
    const translate = useTranslate();

    const { setIsVisible } = props;

    const handleClose = () => {
        setIsVisible(false);
    };

    return (
        <div className='properties__container__info'>
            <p>
                {translate('massive_loading_instructions')}
                <a href={zip} className='linkStye'>
                    {translate('these')}
                </a>
                {translate('massive_loading_instructions_2')}
                <a href={zip} className='linkStye'>
                    {translate('click_here_download')}
                </a>
            </p>
            <IconButton iconName='Close' onClick={handleClose} />
        </div>
    );
};

export default PropertiesMessageInfo;
